import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Remove index.css import as we're using Material UI for styling

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
